import React from 'react';
import {LanguageContext} from '../LanguageContext';
import EN from '../images/GB-en.png';
import RO from '../images/RO-ro.png';

const LanguageSelector = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div className="flex w-full justify-around">
          <div>
            <button
              className={`p-2 m-3 border-solid ${lang.selected === 'EN' ? 'border-2 border-blue rounded' : ''}`}
              onClick={() => changeLanguage('EN')}
            >
              <img src={EN} alt="United Kingdom Flag" />
              <div>English</div>
            </button>
            <button
              className={`p-2 m-3 border-solid ${lang.selected === 'RO' ? 'border-2 border-blue rounded' : ''}`}
              onClick={() => changeLanguage('RO')}
            >
              <img src={RO} alt="Romanian Flag" />
              <div>Romanian</div>
            </button>
          </div>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector.js